import React, { useState } from "react";
import './InboxControl.css';
import FullPagePanel from "components/reusable/FullPagePanel";
import AccountSettingsTabs from "components/account-screen/AccountSettingsTabs";
import Constants from "utilities/js/Constants";
import CookieManager from "utilities/js/localstorage/CookieManager";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import { useQuery } from "@tanstack/react-query";
import { getNotifications } from "utilities/js/callouts/CalloutFactory";
import { isLoggedIn } from "utilities/js/ActionLibrary";
import NotificationScreen from "components/notification-center/NotificationScreen";
import Panel from "components/reusable/Panel";
import DetailPanel from "components/reusable/DetailPanel";

const InboxIcon = Constants.ICON_INBOX;
const EmptyInboxIcon = Constants.ICON_EMPTY_INBOX;

const cookieManager = new CookieManager();

const InboxControl = props => {
    const [isOpen, setIsOpen] = useState(false);

    
    const notificationResponse = useQuery({
        queryKey: ['unreadNotifications'],
        queryFn: () => getNotifications({readStatus: false}),
        staleTime: Infinity,
        enabled: isLoggedIn()
    })

    function toggleNotificationPanel(){
        if(isOpen){
            setIsOpen(false);
            unfreezeBody();
        }else{
            setIsOpen(true);
            freezeBody();
        }
    }

    function closeAccountPanel(){
        setIsOpen(false);
        unfreezeBody();
    }

    function getIcon(){
        if(notificationResponse.data && notificationResponse.data.length > 0){ 
            return (<img src={InboxIcon} className="inbox-icon"></img>);
        }else{
            return (<img src={EmptyInboxIcon} className="inbox-icon"></img>);
        }
    }

    function getInboxButton(){
        if(props.standalone){  
            return (
            <button className="nav-button" onClick={toggleNotificationPanel}>
                {getIcon()}
            </button>
            );
        }else{
            return (
                <div key="account-panel" className="account-panel-container name-display">
                    <div className="account-info-panel-container" onClick={toggleNotificationPanel}>
                        <div className="home-account-icon-container">
                            {getIcon()}
                        </div>
                        <div className="account-info-control-username">Inbox</div>
                    </div>
                </div>
            )
        }
            
    }

    if(isLoggedIn()){
        return (<>
            {getInboxButton()}
            <DetailPanel headerText="Notifications" alignment="right" showClose="true" hideFooter="true" noPadding="true" shouldDisplay={isOpen} closePanel={closeAccountPanel}>
                <NotificationScreen></NotificationScreen>
            </DetailPanel>
        </>);
    }
    
}

export default InboxControl;
